import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarLineasPedidosExcel/descargarPlantillaExcelLineasPedidosExcel`, method: 'GET', body: null, token: token})
}
